import { render, staticRenderFns } from "./SearchLabelBody.vue?vue&type=template&id=4ba368fd&scoped=true&"
import script from "./SearchLabelBody.vue?vue&type=script&lang=js&"
export * from "./SearchLabelBody.vue?vue&type=script&lang=js&"
import style0 from "./SearchLabelBody.vue?vue&type=style&index=0&id=4ba368fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba368fd",
  null
  
)

export default component.exports